<nz-page-header nzTitle="Employer List"></nz-page-header>

<a [routerLink]="['/employer/new']" nz-button nzType="dashed" class="mb-1" >+ Onboard New Employer</a>
<nz-table nzSize="small" [nzData]="[1]" [nzFrontPagination]="false">
	<thead>
		<tr>
			<th>Action</th>
			<th>Name</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of data" (dblclick)="doView(item)">
			<td>
				<a [routerLink]="['/employer',item.id,'view']" class="btn btn-sm btn-secondary">Open</a>
			</td>
			<td>{{item.name}}</td>
		</tr>
	</tbody>
</nz-table>
